export default __webpack_public_path__ + "static/media/logo.e19e2cf2.png";